import yeatiLeaning from "@/assets/images/yeati-leaning.webp";
import { cn } from "@/shared/utils/style.util";

type AuthShowcaseTitleSize = "hero" | "step";

type AuthShowcasePanelProps = {
  titleLines: readonly string[]
  titleAccent: string
  titleSize?: AuthShowcaseTitleSize
};

// Step titles carry longer words than the login hero: one size down keeps
// them clear of the mascot.
const TITLE_SIZE_CLASS: Record<AuthShowcaseTitleSize, string> = {
  hero: "text-5xl xl:text-6xl",
  step: "text-5xl",
};

// Decorative mascot panel of the login journey, hidden on mobile where the
// content comes first.
export const AuthShowcasePanel = ({ titleLines, titleAccent, titleSize = "hero" }: AuthShowcasePanelProps) => (
  <div
    className="relative hidden min-h-[720px] overflow-hidden rounded-[28px] border border-emerald-100 bg-gradient-to-br from-emerald-50 via-sky-50 to-indigo-50 p-10 lg:flex lg:flex-col dark:border-gray-800 dark:from-slate-900 dark:via-slate-900 dark:to-indigo-950"
    aria-hidden
    data-testid="auth-showcase-panel"
  >
    <p className={cn("relative z-10 font-bold leading-[1.1] tracking-tight text-gray-900 dark:text-white", TITLE_SIZE_CLASS[titleSize])}>
      {titleLines.map((line) => <span key={line} className="block">{line}</span>)}
      <span className="block text-primary">{titleAccent}</span>
    </p>
    <img
      src={yeatiLeaning}
      alt=""
      className="pointer-events-none absolute bottom-0 -left-4 h-[55%] w-auto drop-shadow-xl"
    />
  </div>
);

AuthShowcasePanel.displayName = "AuthShowcasePanel";
